import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Embed from './Embed';
import styles from './PreviewEmbed.style';

class PreviewEmbed extends React.Component {
  render() {
    const { classes, form } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.pane}>
          <Grid container spacing={40}>
            <Grid item xs>
              <Typography type="h2" gutterBottom>
                Embed
              </Typography>
              <p className={classes.description}>
                To embed this form on your website, copy/paste the code snippet
                below between the <code>&lt;body&gt;&lt;/body&gt;</code> tags on
                the relevant page.
              </p>
              <Embed form={form} />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

PreviewEmbed.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default withStyles(styles)(PreviewEmbed);
